import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';

import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {UserService} from '../common/user.service';
import { CreditService } from '../common/credit.service';
import { CountryService } from '../common/country.service';


@Component({
  selector: 'app-pay-balance',
  templateUrl: './pay-balance.component.html',
  styleUrls: ['./pay-balance.component.css','../app.component.css'],
  providers: [UserService,CreditService,CountryService]
})
export class PayBalanceComponent implements OnInit {
  userId : any;
  eventId :any;
  balance :any;
  creditCard: any;
  totalBalance:any;
  users:any;
  type: any;
  cardUse:any;
  oldCards:any
  cardArray: any;
  errorMessage: any;
  spinner: boolean = false;

  billingStates:any;
  mainUser:any;
  countries:any;
  eventUserId:any;

  constructor(private router: Router,private creditService: CreditService, public dialogRef: MdDialogRef<PayBalanceComponent>, private snackBar: MdSnackBar,private formBuilder: FormBuilder, private UserService: UserService,private countryService: CountryService) { }

  ngOnInit() {
    if(this.eventId && this.userId && this.type){
      this.cardArray=this.oldCards;
      (this.cardArray.length >0)?this.cardUse='old':this.cardUse='new';
    }else{
      this.snackBar.open('something went wrong','',{duration:4000});
      setTimeout(()=>{ window.location.reload();}, 2000);
    }

    this.users = {
      cardId:'',
      cardFrom:(this.cardArray.length >0)?'old':'new',
      amount: this.balance,
      eventId: this.eventId,
      eventUserId: this.eventUserId,
      userId: this.userId,
      totalBalance:this.totalBalance
    };

    this.creditCard = {
      name : '',
      number : '',
      expMonth : '',
      expYear : '',
      cvv : '',
      cardType : 'visa',
      save : false,
      address1:'',
      address2:'',
      city:'',
      stateId:'',
      state:'',
      zip:'',
      countryId:'',
      country:'',
      sameAsUser:false
    };

    this.countryService.getCountries().subscribe(response => {
      this.countries = response;
      for(var i=0;i<this.countries.length;i++)
        if(this.countries[i].name=='USA')
        {
          this.creditCard.countryId = this.countries[i].id;
          this.billingCountryChanged();
        }
    });
  }

  oldCard(id){
    if(id) {
      this.users.cardId = id;
    }
  }

  cardFrom(type){
    if(type){
      this.users.cardFrom = type;
      if(type=='new'){
        this.users.cardId='';
      }
    }
  }

  cardType(){
    this.creditCard.cardType= this.creditService.parseCardType(this.creditCard.number);
  }



  paymentFormValid(frm){
    var flag = true;
    if(!frm.valid)
      flag = false;
    if(this.users.cardFrom=='new')
    {
      if(flag && !this.validateDigit(this.creditCard.number,14,19))
        flag = false;
      if(flag && !this.validateDigit(this.creditCard.expMonth,2,2))
        flag = false;
      if(flag && !this.validateDigit(this.creditCard.expYear,2,2))
        flag = false;
      if(flag && !this.validateDigit(this.creditCard.cvv,3,4))
        flag = false;
      if(flag && !this.creditCard.address1)
        flag = false;
      if(flag && !this.creditCard.city)
        flag = false;
      if(flag && !this.creditCard.stateId)
        flag = false;
      // if(flag && !this.creditCard.zip)
      //   flag = false;
      if(flag && !this.creditCard.countryId)
        flag = false;
    }
    return flag;
  }

  validateDigit(num,min,max){
    return num.match("^[0-9]{"+min+","+max+"}$");
  }

  billingSameAsUser(){
    this.spinner = true;
    if(this.creditCard.sameAsUser)
    {
      this.creditCard.address1 = this.mainUser.eventUser.addressLine1;
      this.creditCard.address2 = this.mainUser.eventUser.addressLine2;
      this.creditCard.city = this.mainUser.eventUser.city;
      this.creditCard.stateId = this.mainUser.eventUser.stateId;
      this.creditCard.state = this.mainUser.eventUser.stateName;
      this.creditCard.countryId = this.mainUser.eventUser.countryId;
      this.countryService.getStates(this.mainUser.eventUser.countryId).subscribe(
              response => {
            this.spinner = false;
            this.billingStates = response;
          },
              error => {
            this.spinner = false;
          }
      );
      this.creditCard.country  = this.mainUser.eventUser.countryName;
      this.creditCard.zip = this.mainUser.eventUser.zipcode;
    }
    else
    {
      this.spinner = false;
      this.creditCard.address1 = '';
      this.creditCard.address2 = '';
      this.creditCard.city = '';
      this.creditCard.stateId = '';
      this.creditCard.state = '';
      this.creditCard.countryId = '';
      this.creditCard.country = '';
      this.creditCard.zip = '';
    }
  }

  billingStateChanged(){
    for(var i=0;i<this.billingStates.length;i++)
      if(this.billingStates[i].id==this.creditCard.stateId)
        this.creditCard.state = this.billingStates[i].name;
  }

  billingCountryChanged(){
    this.spinner = true;
    this.countryService.getStates(this.creditCard.countryId).subscribe(
            response => {
          this.spinner = false;
          this.billingStates = response;
        },
            error => {
          this.spinner = false;
          this.snackBar.open(error,'',{duration:4000});
        }
    );
    for(var i=0;i<this.countries.length;i++)
      if(this.countries[i].id==this.creditCard.countryId)
        this.creditCard.country = this.countries[i].name;
  }


  validateZip(zip,country){
    return true;
    // if(country=='Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }


  addPay(payForm) {
    if (payForm.valid) {
      this.cardType();
      this.spinner = true;
      this.UserService.saveBalance({users:this.users,creditCard:this.creditCard,type:this.type}).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              this.snackBar.open('Pay balance added Successfully','',{duration:4000});
              this.dialogRef.close(response);
            }
            else {
              this.spinner = false;
              this.snackBar.open(response.message, '', {duration: 4000});
            }
          },
	  error => {
	   this.spinner = false;
	  }
	);
    }
  }

  close() {
    this.dialogRef.close();
  }



}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/pay-balance/pay-balance.component.ts